var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-image-map-message"},[_c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":_vm.baseUrl,"alt":"Preview Image Map"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }